export default __webpack_public_path__ + "static/media/mobile-pan.1051bed0.png";